import React from "react";
import { toast } from "sonner";
import { compressImage, dataUrlSizeBytes } from "../../lib/image";
import { log } from "../../lib/logger";

/** Single-image uploader used across all photo slots on the SellWatch form.
 *  `compact` renders a shorter dropzone (`h-24`) for dense modals. */
export default function PhotoInput({ label, hint, value, onChange, testId, compact = false }) {
  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const url = await compressImage(file);
      onChange(url);
    } catch (err) {
      log.error("[Sell] compress failed:", err);
      toast.error("Could not read this photo — try another one");
    }
  };
  const boxH = compact ? "h-20" : "h-28";
  const previewH = compact ? "h-20" : "h-28";
  return (
    <div className={`glass rounded ${compact ? "p-2" : "p-3"}`}>
      <div className={`text-xs uppercase tracking-widest text-white/60 ${compact ? "mb-0.5" : "mb-1"}`}>{label} <span className="text-gold">*</span></div>
      {hint && <div className={`text-[11px] text-white/40 ${compact ? "mb-1.5" : "mb-2"}`}>{hint}</div>}
      {value ? (
        <div className="relative">
          <img src={value} alt={label} className={`w-full ${previewH} object-cover rounded`} />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">Change</button>
          <div className="text-[10px] text-white/40 mt-1">{Math.round(dataUrlSizeBytes(value) / 1024)} KB</div>
        </div>
      ) : (
        <label className={`block cursor-pointer border-2 border-dashed border-white/20 hover:border-gold rounded ${boxH} flex items-center justify-center text-white/50 text-xs`}>
          Tap to upload
          <input type="file" accept="image/*" className="hidden" onChange={onPick} data-testid={testId} />
        </label>
      )}
    </div>
  );
}
